<template>
  <div
    class="shop-subcategory"
    :class="{ 'shop-subcategory--active': active }"
    @click="$emit('update:active', true)"
  >
    <div class="shop-subcategory__title">{{ value.label }}</div>
    <div class="shop-subcategory__items">
      <template>
        <Product
          v-if="!items.filter(i => i.isDefault).length"
          :selected="!selected"
          :value="{
            product: {
              name: $t('noShopDefaultProduct'),
            },
            isDummy: true,
            isDefault: true,
          }"
          :readonly="readonly"
          show-image
          class="shop-subcategory__item"
          @click="selected && $emit('unselect', selected.id)"
        />
        <Product
          v-for="(item, index) in items"
          :key="index"
          :selected="item.selected"
          :value="item"
          :sets="sets"
          :hide-price="$path('metadata.hidePrice', value)"
          :readonly="readonly"
          show-image
          class="shop-subcategory__item"
          @click="$emit('select', item.id)"
        >
          <template #actions>
            <ButtonComponent
              :label="$t('readMore')"
              class="shop-subcategory__item-modal-trigger"
              @click.stop="$emit('open:modal', item)"
            />
          </template>
        </Product>
      </template>
    </div>
  </div>
</template>

<script>
import Product from './Product/Card'
import { CheckConditions } from './utils'

export default {
  props: {
    value: Object,
    active: Boolean,
    selectedItems: Array,
    readonly: Boolean,
    sets: Array,
  },
  watch: {
    active(val) {
      if (!val) return

      this.$el.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      })
    },
  },
  computed: {
    selected() {
      return this.items.find(i => i.selected)
    },
    items() {
      return this.value.items
        .filter(v => CheckConditions(v, this.selectedItems))
        .sort((a, b) => {
          if (a.isDefault) return -1
          if (b.isDefault) return 1

          return 0
        })
    },
  },
  metaInfo() {
    let preload = []
    if (this.active)
      preload.push(
        ...(this.$path('value.items') || [])
          .map(item => {
            if (!item.images) return
            return item.images.map(i => ({ rel: 'preload', as: 'image', href: i.url }))
          })
          .filter(Boolean)
          .flat(),
      )
    return {
      link: [...preload],
    }
  },
  components: {
    Product,
  },
}
</script>

<style lang="scss">
@import './styles/_variables';

.shop-subcategory {
  $spacing: 3rem;
  position: relative;
  padding: $spacing/2 $spacing;

  &--active,
  &:hover {
    .shop-subcategory__items {
      opacity: 1;
    }
  }

  &--active {
    &:after {
      background: var(--primary) !important;
      box-shadow: 5px 0px 10px 0px hsla(var(--primary-h), var(--primary-s), var(--primary-l), 0.5);
    }
  }

  &:after {
    $size: 2px;

    content: '';
    position: absolute;
    left: -1px;
    top: $spacing/2;
    height: calc(100% - #{$spacing/2});
    width: $size;
    background: transparent;
    transition: background 150ms ease-out;
    border-radius: $border-radius;
  }

  &__title {
    font-weight: bold;
    font-size: 1.4rem;
    margin-bottom: 1rem;
  }

  &__items {
    display: grid;
    grid-gap: 0.5rem;
    opacity: 0.6;

    transition: opacity 150ms ease-out;
  }
  &__item {
    &-modal-trigger {
      font-size: 0.7em !important;
      margin-top: auto;
      margin-left: auto;

      @media (min-width: $shop-responsive) {
        display: none !important;
      }
    }
  }
}
</style>
